import type { ReactNode } from 'react';

/**
 * État vide. Un tableau sans ligne doit dire POURQUOI il est vide (aucun résultat / rien à
 * traiter) et proposer la sortie : c'est la différence entre « le filtre est trop étroit » et
 * « le backend est tombé ».
 */
export function EtatVide({
  titre,
  description,
  action,
}: {
  titre: string;
  description?: string;
  action?: ReactNode;
}): JSX.Element {
  return (
    <div className="gv-vide">
      <p className="gv-vide__titre">{titre}</p>
      {description ? <p className="gv-corps-s">{description}</p> : null}
      {action ? <div className="gv-ligne">{action}</div> : null}
    </div>
  );
}
